import { BuildConfig } from 'env/env.config';
import { VISITED } from 'constants/States';

const { DEFAULT_MAP_CENTER } = BuildConfig;

export const DEFAULT_ZOOM_LEVEL = 12;
const WORLD_DIM = { height: 256, width: 256 };
const ZOOM_MAX = 21;

export const GOOGLE_MAP_ELEMENT_ID = 'embed-google-map';

const getMinAndMaxCoordinates = (markers = []) => {
  const lats = [];
  const lngs = [];

  markers.forEach(({ position }) => {
    if (position && position.lat()) {
      lats.push(position.lat());
    }

    if (position && position.lng()) {
      lngs.push(position.lng());
    }
  });

  if (!lats.length || !lngs.length) {
    return null;
  }

  const maxLat = Math.max(...lats);
  const minLat = Math.min(...lats);

  const maxLng = Math.max(...lngs);
  const minLng = Math.min(...lngs);

  return {
    maxLat,
    maxLng,
    minLat,
    minLng,
  };
};

export const getMapCenter = (markers = []) => {
  if (!markers || !markers.length) {
    return DEFAULT_MAP_CENTER;
  }

  if (markers.length === 1) {
    return (
      (markers[0].position && { lat: markers[0].position.lat(), lng: markers[0].position.lng() }) ||
      DEFAULT_MAP_CENTER
    );
  }

  const coordinates = getMinAndMaxCoordinates(markers);

  if (!coordinates) {
    return DEFAULT_MAP_CENTER;
  }

  const { maxLat, maxLng, minLat, minLng } = coordinates;
  const center = {
    lat: (maxLat - minLat) / 2 + minLat,
    lng: (maxLng - minLng) / 2 + minLng,
  };

  return center;
};

export const getMapZoomLevel = markers => {
  if (!markers || !Array.isArray(markers) || !markers.length) {
    return DEFAULT_ZOOM_LEVEL;
  }

  if (markers.length === 1) {
    return DEFAULT_ZOOM_LEVEL;
  }

  const coordinates = getMinAndMaxCoordinates(markers);

  if (!coordinates) {
    return DEFAULT_ZOOM_LEVEL;
  }

  const mapEl = document.getElementById(GOOGLE_MAP_ELEMENT_ID);
  const { maxLat, maxLng, minLat, minLng } = coordinates;
  const MAP_DIM = {
    height: mapEl ? mapEl.clientHeight : 700,
    width: mapEl ? mapEl.clientWidth : 600,
  };

  function latRad(lat) {
    const sin = Math.sin((lat * Math.PI) / 180);
    const radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
    return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
  }

  function zoom(mapPx, worldPx, fraction) {
    return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
  }

  const latFraction = (latRad(maxLat) - latRad(minLat)) / Math.PI;
  const lngFraction = (maxLng - minLng) / 360;

  const latZoom = zoom(MAP_DIM.height, WORLD_DIM.height, latFraction);
  const lngZoom = zoom(MAP_DIM.width, WORLD_DIM.width, lngFraction);

  return Math.min(latZoom, lngZoom, ZOOM_MAX);
};

export const mapStyles = [
  {
    featureType: 'poi',
    elementType: 'labels.text',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi.business',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
];

export const generateBusStationColor = stationState => {
  if (stationState === VISITED) {
    return '#005695';
  }

  return '#83559d';
};
